// Function loadprofileListingBlock loads the profileListingBlock class by dynamically importing the js on demand if needed

export function loadProfileListingBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-profile-listing-block-chunk" */ '../widgets/profileListingBlock').then(wg => {

		const { ProfileListingBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ProfileListingBlock"]');

		if(!$wg) {
			// console.info('ProfileListingBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ProfileListingBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ProfileListingBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ProfileListingBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ProfileListingBlock widget');

}
